import { TaskCategory, TaskStatus, } from './models';
import { mapAddressFromDto } from '../address/helpers';
const STATUS_MAP = {
    Completed: TaskStatus.Complete,
    Open: TaskStatus.Open,
    Partial: TaskStatus.Partial,
    Cancelled: TaskStatus.Cancelled,
    Unknown: TaskStatus.Unknown,
    Incomplete: TaskStatus.Open,
    Created: TaskStatus.Open,
    Booked: TaskStatus.Complete,
    Locked: TaskStatus.Complete,
    OnRoute: TaskStatus.Complete,
    Arrived: TaskStatus.Complete,
    Undefined: TaskStatus.Unknown,
};
const CATEGORY_MAP = {
    bookPhotographer: TaskCategory.BookPhotographer,
    uploadImages: TaskCategory.UploadImages,
    uploadVideos: TaskCategory.UploadVideos,
    virtualStaging: TaskCategory.VirtualStaging,
    PERSON: TaskCategory.Person,
    BASIC: TaskCategory.Basic,
    BASIC_OPT: TaskCategory.BasicOpt,
    INTRO_OUTRO_SPEAK: TaskCategory.IntroOutroSpeak,
    COPYWRITETEXTS: TaskCategory.CopywriteTexts,
    TEXT: TaskCategory.Text,
    ARIAL: TaskCategory.Arial,
    COMTEXT: TaskCategory.ComText,
    INTRO_OUTRO: TaskCategory.IntroOutro,
    PERSON_INFO: TaskCategory.PersonInfo,
    SPEAK_INPUT: TaskCategory.SpeakInput,
    VIDIBILI_COMMENT: TaskCategory.VidibiliComment,
    combineImages: TaskCategory.CombineImages,
    virtualStaging720: TaskCategory.VirtualStaging720,
    virtualStaging720Commercial: TaskCategory.VirtaulStagingCommercial720,
    virtualStagingCommercial: TaskCategory.VirtualStagingCommercial,
    virtualStagingInDoorRenovation: TaskCategory.VirtualStagingIndoorRenovation,
    virtualStagingOutDoorRenovation: TaskCategory.VirtualStagingOutdoorRenovation,
    virtualStagingRemovalOfObjects: TaskCategory.VirtualStagingRemoveObjects,
    LOCATION: TaskCategory.Location,
    beforeAndAfter: TaskCategory.BeforeAfter,
    'TEXT-STYLE': TaskCategory.NoStyleText,
    SoMeType: TaskCategory.SoMe,
    SoMeSlideshow: TaskCategory.SoMeSlideshow,
    SomeGif: TaskCategory.SomeGif,
    imageSelector: TaskCategory.ImageSelector,
    WhiteboxImageSelector: TaskCategory.WhiteboxImageSelector,
    AITextInput: TaskCategory.AITextInput,
    AITextOverview: TaskCategory.AITextOverview,
    EFKT__BOOK_PHOTOGRAPHER: TaskCategory.BookPhotographer,
    EFKT__UPLOAD_IMAGE: TaskCategory.EfktUploadImage,
    EFKT__NOTE_FIELD: TaskCategory.EfktNoteField,
    EFKT__IMAGE_SELECTOR: TaskCategory.EfktImageSelector,
    EFKT__OUTDOOR_RETOUCHING: TaskCategory.EfktOutdoorRetouching,
    EFKT__INDOOR_RETOUCHING: TaskCategory.EfktIndoorRetouching,
};
export function mapTaskStatusFromDto(dtoStatus) {
    return STATUS_MAP[dtoStatus];
}
export function mapTaskCategoryFromDto(dtoCategory) {
    return CATEGORY_MAP[dtoCategory];
}
const CATEGORY_TO_ORDER_TASK_MAP = {
    [TaskCategory.BookPhotographer]: 'EFKT__BOOK_PHOTOGRAPHER',
    [TaskCategory.EfktUploadImage]: 'EFKT__UPLOAD_IMAGE',
    [TaskCategory.EfktNoteField]: 'EFKT__NOTE_FIELD',
    [TaskCategory.EfktImageSelector]: 'EFKT__IMAGE_SELECTOR',
    [TaskCategory.EfktOutdoorRetouching]: 'EFKT__OUTDOOR_RETOUCHING',
    [TaskCategory.EfktIndoorRetouching]: 'EFKT__INDOOR_RETOUCHING',
};
const STATUS_TO_ORDER_TASK_MAP = {
    [TaskStatus.Open]: ['Incomplete', 'Created', 'Open'],
    [TaskStatus.Partial]: ['Partial'],
    [TaskStatus.Complete]: ['Booked', 'Locked', 'OnRoute', 'Arrived', 'Completed'],
    [TaskStatus.Cancelled]: ['Cancelled'],
    [TaskStatus.Unknown]: ['Undefined'],
};
export function mapTaskCategoryToOrderTaskDto(category) {
    return CATEGORY_TO_ORDER_TASK_MAP[category];
}
export function mapTaskStatusToOrderTaskDtos(status) {
    var _a;
    return (_a = STATUS_TO_ORDER_TASK_MAP[status]) !== null && _a !== void 0 ? _a : [];
}
export function mapTaskFiltersFromOrderTaskFiltersDto({ types, branches }) {
    const statuses = new Set((types !== null && types !== void 0 ? types : []).flatMap(({ statuses: typeStatuses }) => (typeStatuses !== null && typeStatuses !== void 0 ? typeStatuses : []).map(mapTaskStatusFromDto)));
    return {
        categories: (types !== null && types !== void 0 ? types : []).map(({ type }) => mapTaskCategoryFromDto(type)).filter(Boolean),
        statuses: Array.from(statuses).filter(Boolean),
        branches: (branches !== null && branches !== void 0 ? branches : []).map(({ id, name, parentCompany }) => ({
            id,
            name,
            parentCompany: parentCompany !== null && parentCompany !== void 0 ? parentCompany : undefined,
        })),
    };
}
export function mapTextTaskNoteFromDto(dto) {
    return {
        id: dto.id,
        createdAt: new Date(dto.createdAt),
        text: dto.text,
    };
}
export function mapTaskFromDto(dto) {
    var _a, _b;
    return {
        sourceBackend: 'efkt',
        id: dto.id,
        branchId: dto.branchId,
        branchName: dto.branchName,
        caseId: dto.caseId,
        caseReference: dto.caseReference,
        createdAt: new Date(dto.createdAt),
        productName: dto.productName,
        status: mapTaskStatusFromDto(dto.status),
        type: mapTaskCategoryFromDto(dto.type),
        address: dto.address && mapAddressFromDto(dto.address).full,
        orderId: dto.orderId,
        orderLineId: dto.orderLineId,
        salesId: dto.salesId,
        contactPersonId: dto.contactPersonId,
        notes: (_b = (_a = dto.notes) === null || _a === void 0 ? void 0 : _a.map(mapTextTaskNoteFromDto)) !== null && _b !== void 0 ? _b : [],
    };
}
/**
 * The one-line address for a `Compat: Tasks` row.
 *
 * Deliberately a byte-for-byte reimplementation of datahub's `mapFullAddressFromDto`
 * (`datahub/address/helpers.ts`) rather than an import: the compat wire sends datahub's address
 * shape, the same task rows render in both trees and must read identically — but the dependency
 * between the two backends runs datahub -> efkt only, so `efkt/` cannot reach into `datahub/`.
 * Keep the two in sync if either changes. Typed against the all-optional shape so the
 * `GET /api/orders/tasks` row can use it too — the two addresses carry the same eight field names.
 */
function formatCompatTaskAddress(dto) {
    let output = '';
    if (dto.street)
        output += `${dto.street} `;
    if (dto.buildingNumber)
        output += `${dto.buildingNumber}, `;
    if (dto.buildingFloor)
        output += `${dto.buildingFloor}, `;
    if (dto.buildingDoor)
        output += `${dto.buildingDoor}, `;
    if (dto.cityArea)
        output += `${dto.cityArea}, `;
    if (dto.zip)
        output += `${dto.zip} `;
    if (dto.city)
        output += `${dto.city} `;
    if (dto.country)
        output += `${dto.country}`;
    return output.trim();
}
/**
 * `ICompatTaskDto` -> the canonical `ITask`. Separate from `mapTaskFromDto` on purpose: this one is
 * verified against real responses, that one still describes a guessed `/api/task/...` shape.
 *
 * `salesId` and `notes` are absent from the compat row — it carries neither — so they resolve to an
 * empty string and an empty list. Nothing renders `salesId` for an Efkt task today; if something
 * starts to, it needs a real field from BE rather than a default here.
 */
export function mapTaskFromCompatDto(dto) {
    var _a, _b, _c, _d, _e;
    return {
        sourceBackend: 'efkt',
        id: dto.id,
        branchId: dto.branchId,
        branchName: (_a = dto.branchName) !== null && _a !== void 0 ? _a : '',
        caseId: dto.caseId,
        caseReference: (_b = dto.caseReference) !== null && _b !== void 0 ? _b : '',
        createdAt: new Date(dto.createdAt),
        productName: (_c = dto.productName) !== null && _c !== void 0 ? _c : '',
        status: mapTaskStatusFromDto(dto.status),
        type: mapTaskCategoryFromDto(dto.type),
        address: dto.address && formatCompatTaskAddress(dto.address),
        orderId: dto.orderId,
        orderLineId: (_d = dto.orderlineId) !== null && _d !== void 0 ? _d : '',
        salesId: '',
        contactPersonId: (_e = dto.contactPersonUserID) !== null && _e !== void 0 ? _e : '',
        notes: [],
    };
}
export function mapTaskFromOrderTaskListItemDto(dto) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return {
        sourceBackend: 'efkt',
        id: dto.id,
        branchId: (_a = dto.branchId) !== null && _a !== void 0 ? _a : '',
        branchName: (_b = dto.branchName) !== null && _b !== void 0 ? _b : '',
        caseId: (_c = dto.caseId) !== null && _c !== void 0 ? _c : '',
        caseReference: (_d = dto.caseReference) !== null && _d !== void 0 ? _d : '',
        createdAt: new Date(dto.createdAt),
        productName: (_e = dto.productName) !== null && _e !== void 0 ? _e : '',
        status: mapTaskStatusFromDto(dto.status),
        type: mapTaskCategoryFromDto(dto.type),
        // `address` opts out of the gateway's global null-omission, so it arrives as a real `null`.
        address: dto.address ? formatCompatTaskAddress(dto.address) : undefined,
        orderId: (_f = dto.orderId) !== null && _f !== void 0 ? _f : '',
        orderLineId: (_g = dto.orderlineId) !== null && _g !== void 0 ? _g : '',
        salesId: '',
        contactPersonId: (_k = (_j = (_h = dto.contactPeople) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.id) !== null && _k !== void 0 ? _k : '',
        notes: [],
    };
}
export function mapVirtualStagingStyleFromDto({ roomType, imageUrl, furnitures, }) {
    return {
        roomTypeName: roomType,
        url: imageUrl,
        isSelected: false,
        interiorOptions: furnitures.map(({ code, imageUrl: url }) => ({ name: code, url, isSelected: false })),
    };
}
export function mapInterviewQuestionFromDto({ question, answer, yesOrNoQuestion, }) {
    return { question, answer, yesOrNo: yesOrNoQuestion };
}
export function mapAITextQuestionnaireFromDto(dto) {
    var _a;
    return {
        questions: dto.questions.map(mapInterviewQuestionFromDto),
        isSendEmailAvailable: (_a = dto.isSendEmailAvailable) !== null && _a !== void 0 ? _a : false,
    };
}
export function mapCopywriteTextSectionFromDto({ sectionName, content, }) {
    return { sectionName, content };
}
